import React from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonProps } from '../type';

const Button = ({ className, onClick, iconClassName, title, children }: ButtonProps): JSX.Element => {
    return (
        <button className={`pnt-btn ${className}`} title={title} onClick={onClick}>
            {iconClassName && <span className={iconClassName} />}
            {children}
        </button>
    );
};

export default Button;
